import { useEffect, useState } from 'react';
import { detectDevice } from 'src/helpers/utils';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './BuilderIoSlider.module.scss';

export const BuilderIoSliderInputs = [
  {
    type: 'number',
    name: 'id',
    required: true,
  },
  {
    type: 'boolean',
    name: 'loop',
  },
  {
    type: 'number',
    name: 'slidesPerView',
  },
  {
    type: 'number',
    name: 'spaceBetween',
  },
  {
    type: 'number',
    name: 'autoplayDelay',
  },
  {
    type: 'boolean',
    name: 'disableAutoPlayOnInteraction',
  },
];

export type BuilderIoSliderProps = {
  children: JSX.Element;
  id: number;
  breakpoint?: number;
  autoplayDelay?: number;
  disableAutoPlayOnInteraction?: boolean;
  slidesPerView?: number;
  spaceBetween?: number;
  loop?: boolean;
};

export const BuilderIoSlider: React.FC<BuilderIoSliderProps> = ({
  children,
  loop,
  id,
  autoplayDelay,
  slidesPerView = 1,
  spaceBetween = 20,
  disableAutoPlayOnInteraction,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(detectDevice() === 'mobile');
  }, []);

  const swiperConfig = {
    modules: [Pagination, Navigation],
    loop: loop,
    spaceBetween: spaceBetween,
    slidesPerView: isMobile ? 1 : slidesPerView,
    autoplay: {
      delay: autoplayDelay || 0,
      disableOnInteraction: disableAutoPlayOnInteraction,
    },
    navigation: !isMobile && {
      nextEl: `#next_nav_for_${id}`,
      prevEl: `#prev_nav_for_${id}`,
    },
    pagination: isMobile && {
      clickable: true,
      type: 'bullets' as const,
    },
    className: `${styles.swiper} ${isMobile ? styles.mobile : styles.desktop}`,
  };

  return (
    <div id={String(id)} className={styles.sliderContainer}>
      <Swiper {...swiperConfig}>
        {children.props.children.map((child: any, index: number) => (
          <SwiperSlide key={index} className={styles.slide}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Desktop Navigation Arrows */}
      {!isMobile && (
        <>
          <div id={`prev_nav_for_${id}`} className={`${styles.swiperButtonPrev} ${styles.navigationArrow}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div id={`next_nav_for_${id}`} className={`${styles.swiperButtonNext} ${styles.navigationArrow}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 6L15 12L9 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </>
      )}
    </div>
  );
};
